import { cn } from '@/lib/utils'
import React from 'react'

export default function ButtonGroup({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-eslot="button"
      className={cn(
        [
          'flex',
          '[&>[data-eslot=button]:not(:first-child)]:rounded-l-none [&>[data-eslot=button]:not(:last-child)]:rounded-r-none',
          '[&>[data-eslot=button]:not(:first-child)]:border-l-0 [&>[data-eslot=button]:not(:last-child)]:border-r-0',
          '[&>[data-eslot=button]:not(:first-child)]:border-l',
        ],
        className,
      )}
      {...props}
    ></div>
  )
}
